import { IPanelTemplateHasModel } from '@llws/lift-entity-interfaces';
import { QueryStringCommandOptions } from '@/shared';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/panel_template/:param/panel_template_has_model';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: QueryStringCommandOptions = {};

const defaultGetSingleFilters: QueryStringCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementation<IPanelTemplateHasModel>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'panel-template-has-models/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
